import { computed } from "vue";
import { get } from "lodash-es";
import { useNuxtApp } from "#app";
import { useMainStore } from "@/composables/store";
import { isJapanShopStyle } from "@/utils/shopStyle";

export function useJapanStyleSite() {
  const store = useMainStore();
  const { $nowCurrentServer } = useNuxtApp();

  const currentSiteInfo = computed(() => store.getSiteInfo() || {});

  const currentStoreInfo = computed(() => {
    return store.getStoreInfoDataMap($nowCurrentServer.value) || {};
  });

  const currentStorePageInfo = computed(() => {
    return get(currentStoreInfo.value, "storePageInfo", {}) || {};
  });

  const japanStyleConfig = computed(() => {
    return {
      ...currentStoreInfo.value,
      ...currentStorePageInfo.value,
    };
  });

  const isJapanStyle = computed(() => {
    return isJapanShopStyle({
      ...currentSiteInfo.value,
      ...japanStyleConfig.value,
    });
  });

  return {
    currentSiteInfo,
    currentStoreInfo,
    currentStorePageInfo,
    japanStyleConfig,
    isJapanStyle,
  };
}
